import React from "react";

export default function Legend({ className, children }) {
    return <legend className={ className }>{ children }</legend>
}